var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusBarPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 324,
    height: 12,
    rx: 6,
    fill: "#3E4775"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 1.25,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#B3A4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 4.25,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#3E4775",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 4.25,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#CECEEB",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 314.25,
    y: 3.75,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#CECEEB",
    strokeWidth: 2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzI0IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgMzI0IDE0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB5PSIwLjc1IiB3aWR0aD0iMzI0IiBoZWlnaHQ9IjEyIiByeD0iNiIgZmlsbD0iIzNFNDc3NSIvPgo8cmVjdCB4PSIwLjI1IiB5PSIxLjI1IiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHJ4PSI2IiBmaWxsPSIjQjNBNEZGIi8+CjxyZWN0IHg9IjMuMjUiIHk9IjQuMjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIzIiBzdHJva2U9IiMzRTQ3NzUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIxNTkiIHk9IjQuMjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIzIiBzdHJva2U9IiNDRUNFRUIiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIzMTQuMjUiIHk9IjMuNzUiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIzIiBzdHJva2U9IiNDRUNFRUIiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgStatusBarPending as ReactComponent };